export default __webpack_public_path__ + "static/media/event.56e8063c.jpg";